module.exports = __webpack_public_path__ + "media/images/sp/brands/eight/store_eight-f3e710a7457df20e10443e9d4f369b6e.jpg";